import React, { useEffect, useRef, useState } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";
// import "./categoryManagement.responsive.css";

const type = [
    {
        type: "replace"
    },
    {
        type: "discontinue"
    }
]
// for modal design
const BpIcon = styled("span")(({ theme }) => ({
    borderRadius: 3,
    border: "1px solid #b2b3b3",
    width: 12,
    height: 12,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "none",
    backgroundColor: theme.palette.mode === "dark" ? "#394b59" : "transparent",
}));

function BpCheckbox(props) {
    return (
        <Index.Checkbox
            sx={{
                "&:hover": { bgcolor: "transparent" },
            }}
            disableRipple
            color="default"
            checkedIcon={<BpCheckedIcon />}
            icon={<BpIcon />}
            inputProps={{ "aria-label": "Checkbox demo" }}
            {...props}
        />
    );
}

const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: "transparent",
    "&:before": {
        display: "block",
        width: 12,
        height: 12,
        backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
            " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
            "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23114A65'/%3E%3C/svg%3E\")",
        content: '""',
    },
    "input:hover ~ &": {
        backgroundColor: "transparent",
    },
});

const IOSSwitch = Index.styled((props) => (
    <Index.Switch
        focusVisibleClassName=".Mui-focusVisible"
        disableRipple
        {...props}
    />
))(({ theme }) => ({
    width: 34,
    height: 20,
    padding: 0,
    "& .MuiSwitch-switchBase": {
        padding: 0,
        margin: 3,
        transitionDuration: "300ms",
        "&.Mui-checked": {
            transform: "translateX(16px)",
            color: "#fff",
            "& + .MuiSwitch-track": {
                backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#3c0000",
                opacity: 1,
                border: 0,
            },
            "&.Mui-disabled + .MuiSwitch-track": {
                opacity: 0.5,
            },
        },
        "&.Mui-focusVisible .MuiSwitch-thumb": {
            color: "#33cf4d",
            border: "6px solid #fff",
        },
        "&.Mui-disabled .MuiSwitch-thumb": {
            color:
                theme.palette.mode === "light"
                    ? theme.palette.grey[100]
                    : theme.palette.grey[600],
        },
        "&.Mui-disabled + .MuiSwitch-track": {
            opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
        },
    },
    "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        width: 14,
        height: 14,
        boxShadow: "none",
    },
    "& .MuiSwitch-track": {
        borderRadius: 26 / 2,
        backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
        opacity: 1,
        transition: theme.transitions.create(["background-color"], {
            duration: 500,
        }),
    },
}));

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
};

export default function ReplaceCaptionLog() {
    const [activityLoading, setActivityLoading] = useState(true);
    const [filterLog, setFilterLog] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchValue, setSearchValue] = useState("");
    const [openCalenderStart, setOpenCalenderStart] = useState(false);
    const [openCalenderEnd, setOpenCalenderEnd] = useState(false);
    const [salesOrderData, setSalesOrderData] = useState([]);
    const [previousBookingData, setPreviousBookingData] = useState([]);
    const [creativesData, setCreativesData] = useState([]);
    const [subBookingData, setSubBookingData] = useState([]);
    const [advertisorData, setAdvertisorData] = useState([]);

    const formRef = useRef();
    const initialValues = {
        startDate: null,
        endDate: null,
        replace: true,
        discontinue: false,
        client: "",
        campaign: "",
        booking: "",
        subBooking: "",
        creative: "",
        endDate: null,
        replaceCampaign: "",
        replaceStartDate: null,
        replaceEndDate: null,
    };

    // const requestSearch = (e) => {
    //     setSearchValue(e.target.value);
    //     let filteredData = filterLog.filter((data) =>
    //         data?.orderId?.client?.compName
    //             ?.toLowerCase()
    //             .includes(e?.target?.value?.trim()?.toLowerCase())
    //     );
    //     setCurrentPage(1);
    //     setFilteredData(filteredData);
    // };

    const handleGetCategory = () => {
        setActivityLoading(true);
        PagesIndex.apiGetHandler(
            PagesIndex.Api.GET_REPLACE_DISCONTINUE_LOG_LIST
        ).then((res) => {
            setActivityLoading(false);
            if (res.status === 200) {
                let data = res?.data
                setFilterLog(data);
                setFilteredData(data)
            }
        });
    };

    useEffect(() => {
        handleGetCategory();
    }, []);


    const renderActivityTableRows = () => {
        const indexOfLastRow = currentPage * rowsPerPage;
        const indexOfFirstRow = indexOfLastRow - rowsPerPage;

        const sortedData = [...filteredData].sort((a, b) => {
            const aTime = PagesIndex.moment(a.updatedAt).valueOf();
            const bTime = PagesIndex.moment(b.updatedAt).valueOf();
            return bTime - aTime;
        });
        const currentRows = sortedData.slice(indexOfFirstRow, indexOfLastRow);
        return currentRows
            ?.map((data, index) => {

                return (
                    <Index.TableRow
                        sx={{
                            "&:last-child td, &:last-child th": {
                                border: 0,
                            },
                        }}
                        key={data?._id}
                    >
                        <>
                            <Index.TableCell
                                component="td"
                                variant="td"
                                scope="row"
                                className="table-td"
                            >
                                <Index.Tooltip
                                    title={data?.actionType?.charAt(0).toUpperCase() + data?.actionType?.slice(1)}
                                    arrow
                                    placement="top"
                                    className="admin-tooltip"
                                >
                                    <Index.Typography className="admin-table-data-text">
                                        {data?.actionType?.charAt(0).toUpperCase() + data?.actionType?.slice(1)}
                                    </Index.Typography>
                                </Index.Tooltip>
                            </Index.TableCell>

                            <Index.TableCell
                                component="td"
                                variant="td"
                                scope="row"
                                className="table-td"
                            >
                                <Index.Tooltip
                                    title={data?.orderId?.client?.compName}
                                    arrow
                                    placement="top"
                                    className="admin-tooltip"
                                >
                                    <Index.Typography className="admin-table-data-text">
                                        {data?.orderId?.client?.compName ? data?.orderId?.client?.compName : "-"}
                                    </Index.Typography>
                                </Index.Tooltip>
                            </Index.TableCell>

                            <Index.TableCell
                                component="td"
                                variant="td"
                                scope="row"
                                className="table-td"
                            >
                                <Index.Tooltip
                                    title={data?.orderId?.orderNo}
                                    arrow
                                    placement="top"
                                    className="admin-tooltip"
                                >
                                    <Index.Typography className="admin-table-data-text">
                                        {data?.orderId?.orderNo ? data?.orderId?.orderNo : "-"}
                                    </Index.Typography>
                                </Index.Tooltip>
                            </Index.TableCell>

                            <Index.TableCell
                                component="td"
                                variant="td"
                                scope="row"
                                className="table-td"
                            >
                                <Index.Tooltip
                                    title={data?.salesOrderId?.subOrderNo}
                                    arrow
                                    placement="top"
                                    className="admin-tooltip"
                                >
                                    <Index.Typography className="admin-table-data-text">
                                        {data?.salesOrderId?.subOrderNo ? data?.salesOrderId?.subOrderNo : "-"}
                                    </Index.Typography>
                                </Index.Tooltip>
                            </Index.TableCell>

                            <Index.TableCell
                                component="td"
                                variant="td"
                                scope="row"
                                className="table-td"
                            >
                                <Index.Tooltip
                                    title={data?.oldCreativeId?.code}
                                    arrow
                                    placement="top"
                                    className="admin-tooltip"
                                >
                                    <Index.Typography className="admin-table-data-text">
                                        {data?.oldCreativeId?.code}
                                    </Index.Typography>
                                </Index.Tooltip>
                            </Index.TableCell>

                            <Index.TableCell
                                component="td"
                                variant="td"
                                scope="row"
                                className="table-td"
                            >
                                <Index.Tooltip
                                    title={data?.creativeId?.code}
                                    arrow
                                    placement="top"
                                    className="admin-tooltip"
                                >
                                    <Index.Typography className="admin-table-data-text">
                                        {data?.creativeId?.code}
                                    </Index.Typography>
                                </Index.Tooltip>
                            </Index.TableCell>

                            <Index.TableCell
                                component="td"
                                variant="td"
                                scope="row"
                                className="table-td"
                            >
                                <Index.Tooltip
                                    title={PagesIndex.moment(data?.start).format(
                                        "DD/MM/YYYY"
                                    )}
                                    arrow
                                    placement="top"
                                    className="admin-tooltip"
                                >
                                    <Index.Typography className="admin-table-data-text">
                                        {PagesIndex.moment(data?.start).format(
                                            "DD/MM/YYYY"
                                        )}
                                    </Index.Typography>
                                </Index.Tooltip>
                            </Index.TableCell>
                            <Index.TableCell
                                component="td"
                                variant="td"
                                scope="row"
                                className="table-td"
                            >
                                <Index.Tooltip
                                    title={PagesIndex.moment(data?.end).format(
                                        "DD/MM/YYYY"
                                    )}
                                    arrow
                                    placement="top"
                                    className="admin-tooltip"
                                >
                                    <Index.Typography className="admin-table-data-text">
                                        {PagesIndex.moment(data?.end).format(
                                            "DD/MM/YYYY"
                                        )}
                                    </Index.Typography>
                                </Index.Tooltip>
                            </Index.TableCell>



                            <Index.TableCell
                                component="td"
                                variant="td"
                                className="table-td"
                            >
                                {`${data?.actionBy?.name}-${data?.createdAt
                                    ? PagesIndex.moment(data?.createdAt).format(
                                        "DD/MM/YYYY HH:mm:ss"
                                    )
                                    : "-"
                                    }`}
                            </Index.TableCell>
                        </>
                    </Index.TableRow>
                );
            });
    };

    const renderActivityLogContent = () => {
        return (
            <>
                {!activityLoading &&
                    filteredData?.length > 0 &&
                    renderActivityTableRows()}
                {!activityLoading &&
                    (!filteredData ||
                        filteredData.length === 0) && <PagesIndex.DataNotFound />}
            </>
        );
    };

    const exportData = (data, fileName, type) => {
        // Create a link and download the file
        const blob = new Blob([data], { type });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    };
    const generateCSV = async () => {
        let headers = [];
        headers = [
            "Type",
            "Client",
            "Campaign",
            "Booking",
            "Old Creative",
            "New Creative",
            "Start Date",
            "To Date",
            "Updated Date & Time",
        ];
        let modifiedData = filteredData.map((data, index) => {
            let objData = [];
            objData = [
                data?.actionType ? data?.actionType?.charAt(0).toUpperCase() + data?.actionType?.slice(1) : "-",
                data?.orderId?.client?.compName ? data?.orderId?.client?.compName : "-",
                data?.orderId?.orderNo ? data?.orderId?.orderNo : "-",
                data?.salesOrderId?.subOrderNo ? data?.salesOrderId?.subOrderNo : "-",
                data?.oldCreativeId?.code ? data?.oldCreativeId?.code : "-",
                data?.creativeId?.code ? data?.creativeId?.code : "-",
                data?.start
                    ? PagesIndex.moment(data?.start).format("DD/MM/YYYY")
                    : "-",
                data?.end
                    ? PagesIndex.moment(data?.end).format("DD/MM/YYYY")
                    : "-",

                data?.createdAt && data?.actionBy?.name ? `${data?.actionBy?.name}-${data?.createdAt
                    ? PagesIndex.moment(data?.createdAt).format(
                        "DD/MM/YYYY HH:mm:ss"
                    )
                    : "-"
                    }` : "-",
            ];

            return objData.join(",");
        });

        exportData(
            [[headers, ...modifiedData].join("\n")],
            `${PagesIndex.moment(new Date()).format(
                "DD-MM-YYYY"
            )}_Slot_schedule_list.csv`,
            "text/csv"
        );
    };

    const handleGetAdvertiserList = () => {
        PagesIndex.apiGetHandler(PagesIndex.Api.GET_ALL_ADVERTISER).then((res) => {
            if (res?.status === 200) {
                setAdvertisorData(
                    res?.data?.filter((item) => item?.isActive && !item?.isDraft)
                );
            }
        });
    };

    const handleGetSalesOrder = () => {
        PagesIndex.apiGetHandler(PagesIndex.Api.GET_ALL_SALES_ORDERS_LIST).then(
            (res) => {
                if (res.status === 200) {
                    setSalesOrderData(res?.data);
                }
            }
        );
    };

    const handleGetPreviousBookings = (id) => {
        PagesIndex.apiGetHandler(
            PagesIndex.Api.GET_PREVIOUS_BOOKINGS_BY_SALES_ORDER_ID + "/" + id
        ).then((res) => {
            if (res.status === 200) {
                setPreviousBookingData(res?.data);
            }
        });
    };
    const handleGetSubBooking = (id) => {
        PagesIndex.apiGetHandler(PagesIndex.Api.GET_SUB_BOOKING_ID + "/" + id).then(
            (res) => {
                if (res.status === 200) {
                    setSubBookingData(res?.data);
                }
            }
        );
    };
    const handleGetCreatives = (body) => {
        PagesIndex.apiPostHandler(
            PagesIndex.Api.GET_CREATIVE_FOR_SUB_ORDER_ID,
            body
        ).then((res) => {
            if (res.status === 200) {
                setCreativesData(res?.data);
            }
        });
    };


    useEffect(() => {
        handleGetAdvertiserList();
        handleGetSalesOrder();
    }, [])


    const handleSearchFilter = (values) => {
        console.log(values, "values");
        let filteredData = filterLog.filter((data) => {
            let clientMatch = values.client
                ? data?.orderId?.client?._id === values.client
                : true;

            let creativeMatch = values.creative
                ? data?.creativeId?._id === values.creative
                : true;

            let typeMatch = values.type
                ? data?.actionType === values.type
                : true;

            let startDateMatch = values.startDate
                ? new Date(data.start) > new Date(values.startDate)
                : true;

            let endDateMatch = values.endDate
                ? new Date(data.end) <= new Date(new Date(values.endDate).setDate(new Date(values.endDate).getDate() + 1))
                : true;


            return clientMatch && creativeMatch && typeMatch && startDateMatch && endDateMatch;;
        });

        setCurrentPage(1);
        setFilteredData(filteredData);
    };

    return (

        <Index.Box className="admin-dashboard-content admin-user-list-content">
            <Index.Box className="admin-user-list-flex admin-page-title-main">
                <Index.Typography
                    className="admin-page-title admin-user-list-page-title"
                    component="h2"
                    variant="h2"
                >
                    Replace & Discontinue Logs
                </Index.Typography>

                <Index.Box className="admin-userlist-btn-flex">
                    <Index.Box className="admin-search-main">
                        <Index.Box className="admin-search-box">
                            {/* <Index.Box className="admin-form-group">
                                <Index.TextField
                                    fullWidth
                                    id="fullWidth"
                                    className="admin-form-control"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={requestSearch}
                                />
                                <img
                                    src={PagesIndex.Svg.search}
                                    className="admin-search-grey-img admin-icon"
                                    alt="search"
                                ></img>
                            </Index.Box> */}
                        </Index.Box>
                    </Index.Box>

                    <Index.Box className="admin-userlist-inner-btn-flex">
                        {filteredData?.length > 0 && (
                            <Index.Box className="admin-adduser-btn-main btn-main-secondary">
                                <Index.Button
                                    className="admin-adduser-btn btn-secondary"
                                    onClick={generateCSV}
                                >
                                    <img
                                        src={PagesIndex.Svg.exporticon}
                                        className="admin-plus-icon"
                                        alt="plus"
                                    />
                                    <span>Export CSV</span>
                                </Index.Button>
                            </Index.Box>
                        )}
                    </Index.Box>
                </Index.Box>
            </Index.Box>

            <Index.Box className="filter-card common-card">
                <Index.Box className="filter-flex">
                    <Index.Box className="grid-row">
                        <PagesIndex.Formik
                            enableReinitialize
                            onSubmit={handleSearchFilter}
                            initialValues={initialValues}
                            innerRef={formRef}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleSubmit,
                                setFieldValue,
                            }) => (
                                <form onSubmit={handleSubmit} noValidate="novalidate">
                                    <Index.Box sx={{ width: 1 }} className="grid-main">
                                        <Index.Box
                                            display="grid"
                                            gridTemplateColumns="repeat(12, 1fr)"
                                            gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                                        >
                                            <Index.Box
                                                gridColumn={{
                                                    xs: "span 12",
                                                    sm: "span 3",
                                                    md: "span 3",
                                                    lg: "span 3",
                                                }}
                                                className="grid-column"
                                            >
                                                <Index.Box className="admin-input-box admin-add-event-input-box">
                                                    <Index.FormHelperText className="admin-form-lable">
                                                        Client<span className="astrick-sing">*</span>
                                                    </Index.FormHelperText>
                                                    <Index.Box className="admin-form-group">
                                                        <Index.Autocomplete
                                                            className="admin-auto-complete-control"
                                                            options={advertisorData || []}
                                                            id="client"
                                                            closeText={""}
                                                            openText={""}
                                                            clearText={""}
                                                            value={
                                                                values?.client
                                                                    ? advertisorData?.find(
                                                                        (o) => o?._id === values?.client
                                                                    ) ?? null
                                                                    : null
                                                            }
                                                            onChange={(e, value) => {
                                                                setFieldValue("client", value?._id);
                                                                setFieldValue("campaign", "");
                                                                setFieldValue("booking", "");
                                                                setFieldValue("creative", "");
                                                                setFieldValue("replaceCampaign", "");
                                                                setPreviousBookingData([]);
                                                            }}
                                                            getOptionLabel={(option) => `${option?.compName}`}
                                                            renderOption={(props, item) => (
                                                                <li {...props} key={item?._id}>
                                                                    {item?.compName}
                                                                </li>
                                                            )}
                                                            renderInput={(params) => (
                                                                <Index.TextField
                                                                    fullWidth
                                                                    className="admin-form-control"
                                                                    name="client"
                                                                    {...params}
                                                                    size="small"
                                                                    variant="outlined"
                                                                    placeholder="Select Client"
                                                                />
                                                            )}
                                                        />
                                                        {touched.client && errors.client && (
                                                            <PagesIndex.FormHelperText className="admin-error-text">
                                                                {errors.client}
                                                            </PagesIndex.FormHelperText>
                                                        )}
                                                    </Index.Box>
                                                </Index.Box>
                                            </Index.Box>

                                            <Index.Box
                                                gridColumn={{
                                                    xs: "span 12",
                                                    sm: "span 3",
                                                    md: "span 3",
                                                    lg: "span 3",
                                                }}
                                                className="grid-column"
                                            >
                                                <Index.Box className="admin-input-box admin-add-event-input-box">
                                                    <Index.FormHelperText className="admin-form-lable">
                                                        Campaign <span className="astrick-sing">*</span>
                                                    </Index.FormHelperText>
                                                    <Index.Box className="admin-form-group">
                                                        <Index.Autocomplete
                                                            className="admin-auto-complete-control"
                                                            options={
                                                                salesOrderData?.filter(
                                                                    (data) => data?.client === values?.client
                                                                ) || []
                                                            }
                                                            id="campaign"
                                                            closeText={""}
                                                            openText={""}
                                                            clearText={""}
                                                            value={
                                                                values?.campaign
                                                                    ? salesOrderData?.find(
                                                                        (o) => o?._id === values?.campaign
                                                                    ) ?? null
                                                                    : null
                                                            }
                                                            onChange={(e, value) => {
                                                                setFieldValue("campaign", value?._id);
                                                                setFieldValue("booking", "");
                                                                setFieldValue("creative", "");
                                                                if (value?._id) {
                                                                    handleGetPreviousBookings(value?._id);
                                                                } else {
                                                                    setPreviousBookingData([]);
                                                                }
                                                            }}
                                                            getOptionLabel={(option) =>
                                                                `${option?.orderNo}-${option?.campaignName}`
                                                            }
                                                            renderOption={(props, item) => (
                                                                <li {...props} key={item?._id}>
                                                                    {item?.orderNo}-{item?.campaignName}
                                                                </li>
                                                            )}
                                                            renderInput={(params) => (
                                                                <Index.TextField
                                                                    fullWidth
                                                                    className="admin-form-control"
                                                                    name="campaign"
                                                                    {...params}
                                                                    size="small"
                                                                    variant="outlined"
                                                                    placeholder="Select Campaign"
                                                                />
                                                            )}
                                                        />
                                                        {touched.campaign && errors.campaign && (
                                                            <PagesIndex.FormHelperText className="admin-error-text">
                                                                {errors.campaign}
                                                            </PagesIndex.FormHelperText>
                                                        )}
                                                    </Index.Box>
                                                </Index.Box>
                                            </Index.Box>
                                            <Index.Box
                                                gridColumn={{
                                                    xs: "span 12",
                                                    sm: "span 3",
                                                    md: "span 3",
                                                    lg: "span 3",
                                                }}
                                                className="grid-column"
                                            >
                                                <Index.Box className="admin-input-box admin-add-event-input-box">
                                                    <Index.FormHelperText className="admin-form-lable">
                                                        Booking<span className="astrick-sing">*</span>
                                                    </Index.FormHelperText>
                                                    <Index.Box className="admin-form-group">
                                                        <Index.Autocomplete
                                                            className="admin-auto-complete-control"
                                                            options={previousBookingData || []}
                                                            id="booking"
                                                            closeText={""}
                                                            openText={""}
                                                            clearText={""}
                                                            value={
                                                                values?.booking
                                                                    ? previousBookingData?.find(
                                                                        (o) => o?._id === values?.booking
                                                                    ) ?? null
                                                                    : null
                                                            }
                                                            onChange={(e, value) => {
                                                                setFieldValue("booking", value?._id);
                                                                // setFieldValue("endDate", value?.endDate);
                                                                // setFieldValue(
                                                                //   "replaceStartDate",
                                                                //   PagesIndex.dayjs()
                                                                // );
                                                                // setFieldValue(
                                                                //   "replaceEndDate",
                                                                //   PagesIndex.dayjs(value?.endDate)
                                                                // );
                                                                if (value?._id) {
                                                                    handleGetSubBooking(value?._id);
                                                                    handleGetCreatives({
                                                                        type: values?.discontinue
                                                                            ? "discontinue"
                                                                            : "replace",
                                                                        id: value?._id,
                                                                        booking_id: "",
                                                                    });
                                                                } else {
                                                                    setSubBookingData([]);
                                                                    setCreativesData([]);
                                                                }
                                                            }}
                                                            getOptionLabel={(option) =>
                                                                `${option?.subOrderNo}-${option?.name}`
                                                            }
                                                            renderOption={(props, item) => (
                                                                <li {...props} key={item?._id}>
                                                                    {item?.subOrderNo}-{item?.name}
                                                                </li>
                                                            )}
                                                            renderInput={(params) => (
                                                                <Index.TextField
                                                                    fullWidth
                                                                    className="admin-form-control"
                                                                    name="booking"
                                                                    {...params}
                                                                    size="small"
                                                                    variant="outlined"
                                                                    placeholder="Select Booking"
                                                                />
                                                            )}
                                                        />
                                                        {touched.booking && errors.booking && (
                                                            <PagesIndex.FormHelperText className="admin-error-text">
                                                                {errors.booking}
                                                            </PagesIndex.FormHelperText>
                                                        )}
                                                    </Index.Box>
                                                </Index.Box>
                                            </Index.Box>
                                            {values?.discontinue ? (
                                                <Index.Box
                                                    gridColumn={{
                                                        xs: "span 12",
                                                        sm: "span 3",
                                                        md: "span 3",
                                                        lg: "span 3",
                                                    }}
                                                    className="grid-column"
                                                >
                                                    <Index.Box className="admin-input-box admin-add-event-input-box">
                                                        <Index.FormHelperText className="admin-form-lable">
                                                            Booking<span className="astrick-sing">*</span>
                                                        </Index.FormHelperText>
                                                        <Index.Box className="admin-form-group">
                                                            <Index.Autocomplete
                                                                className="admin-auto-complete-control"
                                                                options={subBookingData || []}
                                                                id="booking"
                                                                closeText={""}
                                                                openText={""}
                                                                clearText={""}
                                                                value={
                                                                    values?.subBooking
                                                                        ? subBookingData?.find(
                                                                            (o) => o === values?.subBooking
                                                                        ) ?? null
                                                                        : null
                                                                }
                                                                onChange={(e, value) => {
                                                                    setFieldValue("subBooking", value);
                                                                    setFieldValue("creative", "");
                                                                    if (value) {
                                                                        handleGetCreatives({
                                                                            type: values?.discontinue
                                                                                ? "discontinue"
                                                                                : "replace",
                                                                            id: values?.booking,
                                                                            booking_id: value,
                                                                        });
                                                                    } else {
                                                                        setCreativesData([]);
                                                                    }
                                                                }}
                                                                getOptionLabel={(option) => option}
                                                                renderOption={(props, item) => (
                                                                    <li {...props} key={item}>
                                                                        {item}
                                                                    </li>
                                                                )}
                                                                renderInput={(params) => (
                                                                    <Index.TextField
                                                                        fullWidth
                                                                        className="admin-form-control"
                                                                        name="subBooking"
                                                                        {...params}
                                                                        size="small"
                                                                        variant="outlined"
                                                                        placeholder="Select Booking"
                                                                    />
                                                                )}
                                                            />
                                                            {touched.subBooking && errors.subBooking && (
                                                                <PagesIndex.FormHelperText className="admin-error-text">
                                                                    {errors.subBooking}
                                                                </PagesIndex.FormHelperText>
                                                            )}
                                                        </Index.Box>
                                                    </Index.Box>
                                                </Index.Box>
                                            ) : (
                                                <></>
                                            )}
                                            <Index.Box
                                                gridColumn={{
                                                    xs: "span 12",
                                                    sm: "span 3",
                                                    md: "span 3",
                                                    lg: "span 3",
                                                }}
                                                className="grid-column"
                                            >
                                                <Index.Box className="admin-input-box admin-add-event-input-box">
                                                    <Index.FormHelperText className="admin-form-lable">
                                                        Creative<span className="astrick-sing">*</span>
                                                    </Index.FormHelperText>
                                                    <Index.Box className="admin-form-group">
                                                        <Index.Autocomplete
                                                            className="admin-auto-complete-control"
                                                            options={creativesData || []}
                                                            id="creative"
                                                            closeText={""}
                                                            openText={""}
                                                            clearText={""}
                                                            value={
                                                                values?.creative
                                                                    ? creativesData?.find(
                                                                        (o) => o?._id === values?.creative
                                                                    ) ?? null
                                                                    : null
                                                            }
                                                            onChange={(e, value) => {
                                                                setFieldValue("creative", value?._id);
                                                            }}
                                                            getOptionLabel={(option) =>
                                                                option?.duration
                                                                    ? `${option?.code}-${option?.name}-${option?.duration} Sec`
                                                                    : `${option?.code}-${option?.name}`
                                                            }
                                                            renderOption={(props, item) => (
                                                                <li {...props} key={item?._id}>
                                                                    {item?.duration
                                                                        ? `${item?.code}-${item?.name}-${item?.duration} Sec`
                                                                        : `${item?.code}-${item?.name}`}
                                                                </li>
                                                            )}
                                                            renderInput={(params) => (
                                                                <Index.TextField
                                                                    fullWidth
                                                                    className="admin-form-control"
                                                                    name="creative"
                                                                    {...params}
                                                                    size="small"
                                                                    variant="outlined"
                                                                    placeholder="Select Creative"
                                                                />
                                                            )}
                                                        />
                                                        {touched.creative && errors.creative && (
                                                            <PagesIndex.FormHelperText className="admin-error-text">
                                                                {errors.creative}
                                                            </PagesIndex.FormHelperText>
                                                        )}
                                                    </Index.Box>
                                                </Index.Box>
                                            </Index.Box>
                                        </Index.Box>

                                        <Index.Box
                                            display="grid"
                                            gridTemplateColumns="repeat(12, 1fr)"
                                            gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                                        >

                                            <Index.Box
                                                gridColumn={{
                                                    xs: "span 12",
                                                    sm: "span 3",
                                                    md: "span 3",
                                                    lg: "span 3",
                                                }}
                                                className="grid-column"
                                            >
                                                <Index.Box className="admin-input-box admin-add-event-input-box">
                                                    <Index.FormHelperText className="admin-form-lable">
                                                        Type<span className="astrick-sing">*</span>
                                                    </Index.FormHelperText>
                                                    <Index.Box className="admin-form-group">
                                                        <Index.Autocomplete
                                                            className="admin-auto-complete-control"
                                                            options={type || []}
                                                            id="type"
                                                            closeText={""}
                                                            openText={""}
                                                            clearText={""}
                                                            value={
                                                                values?.type
                                                            }
                                                            onChange={(e, value) => {
                                                                setFieldValue("type", value?.type);
                                                            }}
                                                            getOptionLabel={(option) => `${option?.type}`}
                                                            renderOption={(props, item) => (
                                                                <li {...props} key={item?._id}>
                                                                    {item?.type}
                                                                </li>
                                                            )}
                                                            renderInput={(params) => (
                                                                <Index.TextField
                                                                    fullWidth
                                                                    className="admin-form-control"
                                                                    name="client"
                                                                    {...params}
                                                                    size="small"
                                                                    variant="outlined"
                                                                    placeholder="Select Type"
                                                                />
                                                            )}
                                                        />
                                                    </Index.Box>
                                                </Index.Box>
                                            </Index.Box>

                                            <Index.Box
                                                gridColumn={{
                                                    xs: "span 12",
                                                    sm: "span 2",
                                                    md: "span 2",
                                                    lg: "span 2",
                                                }}
                                                className="grid-column"
                                            >
                                                <Index.Box className="admin-input-box advertiser-filter-input admin-date-input-main">
                                                    <Index.FormHelperText className="admin-form-lable">
                                                        <span>From Date</span>
                                                    </Index.FormHelperText>
                                                    <Index.Box className="admin-form-group">
                                                        <PagesIndex.LocalizationProvider
                                                            dateAdapter={PagesIndex.AdapterDayjs}
                                                            className="date-localization-main"
                                                        >
                                                            <PagesIndex.DatePicker
                                                                open={openCalenderStart}
                                                                onClose={() => setOpenCalenderStart(false)}
                                                                className="admin-form-control admin-date-picker-control"
                                                                value={values.startDate}
                                                                onChange={(date) => {
                                                                    setFieldValue("startDate", date);
                                                                    setFieldValue("endDate", null);
                                                                }}
                                                                slotProps={{
                                                                    popper: {
                                                                        className: "date-picker-body",
                                                                    },
                                                                    textField: {
                                                                        readOnly: true,
                                                                        onClick: () => setOpenCalenderStart(true),
                                                                    },
                                                                    inputAdornment: {
                                                                        onClick: () => setOpenCalenderStart(true), // This triggers on the calendar icon
                                                                    },
                                                                }}
                                                                format="DD/MM/YYYY"
                                                            />
                                                        </PagesIndex.LocalizationProvider>
                                                    </Index.Box>
                                                    <PagesIndex.FormHelperText className="admin-error-text">
                                                        {errors.startDate && touched.startDate
                                                            ? errors.startDate
                                                            : null}
                                                    </PagesIndex.FormHelperText>
                                                </Index.Box>
                                            </Index.Box>
                                            <Index.Box
                                                gridColumn={{
                                                    xs: "span 12",
                                                    sm: "span 2",
                                                    md: "span 2",
                                                    lg: "span 2",
                                                }}
                                                className="grid-column"
                                            >
                                                <Index.Box className="admin-input-box advertiser-filter-input admin-date-input-main">
                                                    <Index.FormHelperText className="admin-form-lable">
                                                        <span>To Date</span>
                                                    </Index.FormHelperText>
                                                    <Index.Box className="admin-form-group">
                                                        <PagesIndex.LocalizationProvider
                                                            dateAdapter={PagesIndex.AdapterDayjs}
                                                            className="date-localization-main"
                                                        >
                                                            <PagesIndex.DatePicker
                                                                open={openCalenderEnd}
                                                                onClose={() => setOpenCalenderEnd(false)}
                                                                className="admin-form-control admin-date-picker-control"
                                                                value={values.endDate}
                                                                minDate={dayjs(values.startDate).add(
                                                                    0,
                                                                    "day"
                                                                )}
                                                                onChange={(date) => {
                                                                    setFieldValue("endDate", date);
                                                                }}
                                                                slotProps={{
                                                                    popper: {
                                                                        className: "date-picker-body",
                                                                    },
                                                                    textField: {
                                                                        readOnly: true,
                                                                        onClick: () => setOpenCalenderEnd(true),
                                                                    },
                                                                    inputAdornment: {
                                                                        onClick: () => setOpenCalenderEnd(true), // This triggers on the calendar icon
                                                                    },
                                                                }}
                                                                format="DD/MM/YYYY"
                                                            />
                                                        </PagesIndex.LocalizationProvider>
                                                    </Index.Box>
                                                    <PagesIndex.FormHelperText className="admin-error-text">
                                                        {errors.endDate && touched.endDate
                                                            ? errors.endDate
                                                            : null}
                                                    </PagesIndex.FormHelperText>
                                                </Index.Box>
                                            </Index.Box>
                                        </Index.Box>
                                    </Index.Box>
                                    <Index.Box sx={{ width: 1 }} className="grid-main">
                                        <Index.Box
                                            className="filter-row"
                                            display="grid"
                                            gridTemplateColumns="repeat(12, 1fr)"
                                            gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                                        >
                                            <Index.Box
                                                gridColumn={{
                                                    xs: "span 12",
                                                    sm: "span 12",
                                                    md: "span 12",
                                                    lg: "span 12",
                                                }}
                                                className="grid-column"
                                            >
                                                <Index.Box className="filter-btns">
                                                    <Index.Tooltip
                                                        title="Search"
                                                        arrow
                                                        placement="top"
                                                        className="admin-tooltip"
                                                    >
                                                        <Index.Box className="btn-main-primary admin-icons-btn-main">
                                                            <Index.Button
                                                                className="btn-primary admin-icons-btn"
                                                                type="submit"
                                                            // onClick={() =>
                                                            //     setFieldValue("isSubmit", true)
                                                            // }
                                                            >
                                                                <img
                                                                    src={PagesIndex.Svg.searchwhite}
                                                                    className="admin-icons"
                                                                    alt="Save data"
                                                                />
                                                            </Index.Button>
                                                        </Index.Box>
                                                    </Index.Tooltip>
                                                    <Index.Tooltip
                                                        title="Reset"
                                                        arrow
                                                        placement="top"
                                                        className="admin-tooltip"
                                                    >
                                                        <Index.Box className="btn-main-primary admin-icons-btn-main">
                                                            <Index.Button
                                                                className="btn-primary admin-icons-btn"
                                                                onClick={() => {
                                                                    formRef?.current?.resetForm();
                                                                    setCurrentPage(1);
                                                                    setTimeout(() => {
                                                                        handleGetCategory();
                                                                    }, 1000);
                                                                }}
                                                            >
                                                                <img
                                                                    src={PagesIndex.Svg.reset}
                                                                    className="admin-icons"
                                                                    alt="Reset"
                                                                />
                                                            </Index.Button>
                                                        </Index.Box>
                                                    </Index.Tooltip>
                                                </Index.Box>
                                            </Index.Box>
                                        </Index.Box>
                                    </Index.Box>
                                </form>
                            )}
                        </PagesIndex.Formik>
                    </Index.Box>
                </Index.Box>
            </Index.Box>


            <Index.Box className="common-card">
                <Index.Box
                    className={`admin-category-table-main ${activityLoading ? "" : "page-table-main"
                        }`}
                >
                    <Index.TableContainer
                        component={Index.Paper}
                        className="table-container"
                    >
                        {activityLoading ? (
                            <PagesIndex.Loader />
                        ) : (
                            <Index.Table aria-label="simple table" className="table">
                                <Index.TableHead className="table-head">
                                    <Index.TableRow className="table-row">
                                        <Index.TableCell
                                            component="th"
                                            variant="th"
                                            className="table-th"
                                            width="7%"
                                        >
                                            Type
                                        </Index.TableCell>
                                        <Index.TableCell
                                            component="th"
                                            variant="th"
                                            className="table-th"
                                            width="20%"
                                        >
                                            Client
                                        </Index.TableCell>
                                        <Index.TableCell
                                            component="th"
                                            variant="th"
                                            className="table-th"
                                            width="10%"
                                        >
                                            Campaign
                                        </Index.TableCell>
                                        <Index.TableCell
                                            component="th"
                                            variant="th"
                                            className="table-th"
                                            width="10%"
                                        >
                                            Booking
                                        </Index.TableCell>
                                        <Index.TableCell
                                            component="th"
                                            variant="th"
                                            className="table-th"
                                            width="15%"
                                        >
                                            Old Creative
                                        </Index.TableCell>
                                        <Index.TableCell
                                            component="th"
                                            variant="th"
                                            className="table-th"
                                            width="15%"
                                        >
                                            New Creative
                                        </Index.TableCell>
                                        <Index.TableCell
                                            component="th"
                                            variant="th"
                                            className="table-th"
                                            width="10%"
                                        >
                                            Start Date
                                        </Index.TableCell>
                                        <Index.TableCell
                                            component="th"
                                            variant="th"
                                            className="table-th"
                                            width="10%"
                                        >
                                            To Date
                                        </Index.TableCell>

                                        <Index.TableCell
                                            component="th"
                                            variant="th"
                                            className="table-th"
                                            width="25%"
                                        >
                                            Updated Date & Time
                                        </Index.TableCell>

                                    </Index.TableRow>
                                </Index.TableHead>
                                <Index.TableBody className="table-body">
                                    {renderActivityLogContent()}
                                </Index.TableBody>
                            </Index.Table>
                        )}
                    </Index.TableContainer>
                </Index.Box>
                <Index.Box className="admin-pagination-main">
                    {filteredData?.length ? (
                        <Index.Pagination
                            count={Math.ceil(filteredData.length / rowsPerPage)} // total pages
                            page={currentPage}
                            onChange={(event, value) => setCurrentPage(value)}
                            variant="outlined"
                            shape="rounded"
                            className="admin-pagination"
                        />
                    ) : (
                        ""
                    )}
                </Index.Box>
            </Index.Box>
        </Index.Box>
    );
}
